import { OnDestroy, Directive } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppInjector } from '@shared/services/app-injector.service';
import { AccountService } from '../../account/account.service';
import { EventsService } from '../events.service';
import { EventsServicePublic } from '@layouts/default/layouts/guest/pages/events/events.service';
import { BaseComponent } from '@shared/components/base.component';
import { User } from '@shared/models/user/user.model';
import * as moment from 'moment';

@Directive()
export class BaseEventsComponent extends BaseComponent implements OnDestroy {
  accountService: AccountService;
  someSubscriptions: Subscription = new Subscription();
  loading: boolean = false;
  eventService: EventsService;
  eventsServicePublic: EventsServicePublic;

  constructor() {
    super();
    const injector = AppInjector.getInjector();
    this.accountService = injector.get(AccountService);
    this.eventService = injector.get(EventsService);
    this.eventsServicePublic = injector.get(EventsServicePublic);
  }

  checkUserHaveAllInfo(user: User) {
    return (
      !user.name ||
      !user.surname
    );
  }

  checkUserHaveAllYear(user: User) {
    const res = moment().diff(moment(user.birthday, this.Config.DATE_FORMAT_BACKEND), 'years');
    return res < 18;
  }

  ngOnDestroy() {
    this.someSubscriptions.unsubscribe();
  }
}
